import { inject, Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { deepCopy, LifeSign, NetworkConstants } from 'diwimamodelweb/lib';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { skipWhile, take, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SettingsService } from './settings.service';
import { UserService } from './user.service';
import { collection, collectionData, doc, Firestore, query, setDoc, where } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class LifeSignService {
  private Ifirestore = inject(Firestore);

  ngUnsubscribe: Subject<void> = new Subject<void>();
  subscriptions: Map<string, Subscription> = new Map([])
  subbedContext: string|undefined = undefined

  lifeSignsSubject$ = new BehaviorSubject<LifeSign[]>(undefined)

  constructor(
    private settingsService: SettingsService,
    private firestore: AngularFirestore,
    private userService: UserService,
  ) { }

  observeData(contextId) {
    if (this.subbedContext == contextId) return 
    if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    if (!!this.lifeSignsSubject$.value) this.lifeSignsSubject$.next(undefined)
    const sub = this.observeLifeSigns(contextId)
    this.subscriptions.set('1', sub)
    this.subbedContext = contextId
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.subbedContext = undefined
    this.subscriptions.forEach((value) => {
      value.unsubscribe()
    })
    return Promise.resolve()
  }

  observeLifeSigns(contextId: string) {
    const filterDateTwoWeeksPrior = new Date(new Date().setDate(new Date().getDate() - 14))
    // return this.firestore.collection(NetworkConstants.COLLECTION_LIFE_SIGN, ref => ref.where('contextId', "==", contextId).where('updateTimestamp', '>', filterDateTwoWeeksPrior) ).valueChanges()

    const path = `${NetworkConstants.COLLECTION_LIFE_SIGN}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('contextId', '==', contextId), where('updateTimestamp', '>', filterDateTwoWeeksPrior))

    return collectionData(q)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(async (values: any[]) => {
        // values to person 
        var list: LifeSign[] = []
        values.forEach((element: any) => {
          const lifeSign = new LifeSign()
          lifeSign.setFromAny(element)
          list.push(lifeSign)
        })
        this.lifeSignsSubject$.next(list)
      })
  }

  async saveLifeSign(contextId: string): Promise<undefined> {
    //console.log('save lifesign')
    const now = new Date()
    const user = await this.userService.user$.pipe(take(1)).toPromise()
    const agentSplit = window.navigator.userAgent.split("/")
    let agent = "Unknown"
    if (agentSplit.length > 1) agent = agentSplit[0]
    const lifeSign  = new LifeSign(
      environment.appName,
      contextId,
      `Browser_${agent}`,
      user.identifier,
      user.displayName
    )
    try {
      if (!lifeSign.identifier) throw new Error("Insuficient data for lifesign")
      if (!lifeSign.timeStamp) lifeSign.timeStamp = now
      lifeSign.updateTimestamp = now
      const ls = deepCopy(lifeSign, lifeSign.replacerFn)
      // await this.firestore.collection(NetworkConstants.COLLECTION_LIFE_SIGN).doc(lifeSign.identifier).set(ls, {merge: true})

      const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_LIFE_SIGN, lifeSign.identifier)
      await setDoc(docRef,ls, {merge:true} )

      //console.log("saving lifesign")
      return undefined
    } catch (error) {
      console.error(error)
      return error
    }
  }
}
